import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {
  ConservazioneCaricaDocumentoPodStep2Component
} from './conservazione-carica-documento-pod-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-pod-step2', {
            url: '/conservazione-carica-POD',
            ncyBreadcrumb: {
                label: 'Carica POD',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-pod-step2 flex="100"></conservazione-carica-documento-pod-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoPodStep2Module: string = ng
    .module('conservazione-carica-documento-pod-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoPodStep2', ConservazioneCaricaDocumentoPodStep2Component)
    .config(stateConfig)
    .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-pod-step2/conservazione-carica-documento-pod-step2.module.ts